module.exports = __webpack_public_path__ + "static/media/product_640-3.64ed27c9.jpg";